/*
  Perspective MTL · motion (docs/brief/03: earth, wind, ocean, fire).
  CSS does all the moving. This file only:
  - confirms .motion-ready on <html> (set before first paint by the inline
    gate in layout/theme.liquid; without JS or with the theme's motion
    setting off it is never set, so the site reads fully);
  - adds .is-in to [data-reveal] elements once, as they enter the view;
  - measures connector paths so they can draw themselves (Chrome ignores
    pathLength on a non-scaling 1px stroke);
  - adds .is-playing to [data-loops] scopes only while they are in view;
  - gives each swaying sprig its own duration and delay so none sync.
*/
(() => {
  const root = document.documentElement;
  if (document.body.dataset.motion === 'off' || !('IntersectionObserver' in window)) return;
  window.pmMotion = true; // tells the inline gate in theme.liquid we are running
  root.classList.add('motion-ready');

  // Set each path's length before it is revealed, with transitions off,
  // so it starts hidden and only draws when it enters the view.
  const measure = (el) => {
    const line = el.querySelector('.connector__svg polyline');
    if (!line) return;
    const box = line.ownerSVGElement.getBoundingClientRect();
    if (!box.width) return; // hidden (mobile uses the vertical rail)
    const pts = line.getAttribute('points').trim().split(/\s+/).map((p) => p.split(',').map(Number));
    let len = 0;
    for (let i = 1; i < pts.length; i++) {
      len += Math.hypot(((pts[i][0] - pts[i - 1][0]) * box.width) / 100, ((pts[i][1] - pts[i - 1][1]) * box.height) / 100);
    }
    line.style.transition = 'none';
    el.style.setProperty('--len', `${Math.ceil(len)}px`);
    line.getBoundingClientRect(); // commit the hidden start state
    line.style.transition = '';
    line.addEventListener('transitionend', () => el.classList.add('is-drawn'), { once: true });
  };

  const reveal = (el) => el.classList.add('is-in');

  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      reveal(entry.target);
      io.unobserve(entry.target); // each element animates once
    }
  }, { rootMargin: '0px 0px -8% 0px' });

  const loops = new IntersectionObserver((entries) => {
    for (const entry of entries) entry.target.classList.toggle('is-playing', entry.isIntersecting);
  });

  const init = (scope) => {
    scope.querySelectorAll('[data-reveal="draw"]:not(.is-in)').forEach(measure);
    scope.querySelectorAll('[data-reveal]:not(.is-in)').forEach((el) => io.observe(el));
    scope.querySelectorAll('[data-loops]').forEach((el) => loops.observe(el));
    scope.querySelectorAll('[data-sway]').forEach((el, i) => {
      el.style.setProperty('--sway-dur', `${(7 + ((i * 0.77) % 2)).toFixed(2)}s`);
      el.style.setProperty('--sway-delay', `${(-((i * 2.3) % 6)).toFixed(2)}s`);
    });
  };
  init(document);

  // Theme editor: sections re-render in place, so pick up the new markup.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
